/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import XSvg from "components/icons/common/XSvg";
import { toast } from "react-hot-toast";
import { v4 as uuid } from "uuid";
// This function is used to handle passing the Figma styles to the toast
type ToastType = "success" | "error" | "warning" | "new" | "default";
enum ToastVariantLabel {
  success = "Success",
  error = "Error",
  warning = "Attention",
  new = "New Feature",
}

const toastBadgeLabelStyle = {
  error: {
    color: "#240C08",
    backgroundColor: "#E46D64"
  },
  warning: {
    color: "#4C3B1A",
    backgroundColor: "#FFD165"
  },
  success: {
    color: "#3C3C3C",
    backgroundColor: "#A7FFBA"
  },
  new: {
    color: "white",
    backgroundColor: "#3C3C3C"
  },
  default: {}
};

const ToastBadge = ({ type }: { type: ToastType; }) => {
  if (type === "default") return null;
  return (
    <div
      className={
        "py-0.5 px-2 h-full flex items-center justify-start font-medium rounded-2xl text-sm "
      }
      style={toastBadgeLabelStyle[type]}
      test-id="aS_WXa_r"
    >
      <span className="" test-id="vR6awXkG">{ToastVariantLabel[type]}</span>
    </div>
  );
};

const openToast = (message: string, type: ToastType = "default", duration = 5000) => {
  const toastId = uuid();
  const closeToast = () => toast.dismiss(toastId);
  let icon = <ToastBadge type={type} test-id="pJ6NPHMT" />,
    style;
  if (type === "error") {
    style = {
      color: "#FDA29B"
    };
  }
  if (type === "success") {
    style = {
      color: "#A7FFBA"
    };
  }
  if (type === "warning") {
    style = {
      color: "#FFD165"
    };
  }
  if (type === "new") {
    style = {
      color: "#3C3C3C",
      backgroundColor: "white"
    };
  }
  const Message = ({ message }: { message: string }) => (
    <div className="flex items-center gap-x-2 text-sm">
      {message}
      <button onClick={closeToast}><XSvg fill={type === "new" ? "black" : "white"} width="18" height="18" /></button>
    </div>
  )
  return toast(<Message message={message} />, {
    icon,
    duration,
    id: toastId,
    style: {
      ...style,
      borderRadius: "20px",
      fontSize: "14px",
      padding: "6px",
      alignItems: "center"
    },
  },
  );
};

export default openToast;